// Kids info
const kids_data = {
  en: {
    title: "Stories of Kids",
    featured_title: "Featured Kids",
    subtitle: "Learn more about the kids we support",
    featured_kids_ids: [0, 1, 2],
    collection: [
      {
        name: "Nidhi",
        age: "10 years old",
        country: "India",
        short_desc: "10 years old Nihi from India",
        desc: [
          "Nidhi hails from a small village in India. She is a very bright student and loves to draw and paint. She is very fond of animals and nature. She is a very kind and caring person and loves to help others. She is very excited to be a part of this initiative and hopes to help other kids like her.",
        ],
        img: "/assets/images/kids/nidhi.jpg",
        id: "0",
        ngo_name: "Smile Foundation",
        ngo_id: "1",
      },
      {
        name: "Samuel",
        age: "14 years old",
        country: "Syria",
        short_desc: "14 years old Samuel from Syria",
        desc: [
          "Samuel is a very talented artist. He loves to draw and paint. He is very fond of animals and nature. He is a very kind and caring person and loves to help others. He is very excited to be a part of this initiative and hopes to help other kids like him.",
        ],
        img: "/assets/images/kids/samuel.jpg",
        id: "1",
        ngo_name: "The Children's Inn at NIH",
        ngo_id: "0",
      },
      {
        name: "Hamid",
        age: "12 years old",
        country: "Afghanistan",
        short_desc: "12 years old Hamid from Afghanistan",
        desc: [
          "Hamid is a very talented artist. He loves to draw and paint. He is very fond of animals and nature. He is a very kind and caring person and loves to help others. He is very excited to be a part of this initiative and hopes to help other kids like him.",
        ],
        img: "/assets/images/kids/hamid.jpg",
        id: "2",
        ngo_name: "Children First Canada",
        ngo_id: "2",
      },
      {
        name: "Aarav",
        age: "10 years old",
        country: "Iran",
        short_desc: "10 years old Aarav from Iran",
        desc: [
          "Aarav hails from the underpriviledged part of northern Iran. He is a very bright student and has a keen interest in science whose ability to purse his dreams is limited by his family's financial situation.",
        ],
        img: "/assets/images/kids/aarav.jpg",
        id: "3",
        ngo_name: "Smile Foundation",
        ngo_id: "1",
      },
      {
        name: "Sara",
        age: "8 years old",
        country: "Syria",
        short_desc: "8 years old Sara from Syria",
        desc: [
          "Sara hails from the underpriviledged part of northern Iran. She is a very bright student and has a keen interest in science whose ability to purse her dreams is limited by her family's financial situation.",
        ],
        img: "/assets/images/kids/sara.jpg",
        id: "4",
        ngo_name: "The Children's Inn at NIH",
        ngo_id: "0",
      },
    ],
  },
  fr: {
    title: "Histoires d'enfants",
    featured_title: "Enfants en vedette",
    subtitle: "En savoir plus sur les enfants que nous soutenons",
    featured_kids_ids: [0, 1, 2],
    collection: [
      {
        name: "Nidhi",
        age: "10 ans",
        country: "India",
        short_desc: "Nidhi, 10 ans, de l'India",
        desc: [
          "Nidhi vient d'un petit village en Inde. C'est une élève très brillante et elle aime dessiner et peindre. Elle aime beaucoup les animaux et la nature. C'est une personne très gentille et attentionnée et elle aime aider les autres. Elle est très heureuse de faire partie de cette initiative et espère aider d'autres enfants comme elle.",
        ],
        img: "/assets/images/kids/nidhi.jpg",
        id: "0",
        ngo_name: "Smile Foundation",
        ngo_id: "1",
      },
      {
        name: "Samuel",
        age: "14 ans",
        country: "Syria",
        short_desc: "Samuel, 14 ans, de l'Syria",
        desc: [
          "Samuel est un artiste très talentueux. Il aime dessiner et peindre. Il aime beaucoup les animaux et la nature. C'est une personne très gentille et attentionnée et il aime aider les autres. Il est très heureux de faire partie de cette initiative et espère aider d'autres enfants comme lui.",
        ],
        img: "/assets/images/kids/samuel.jpg",
        id: "1",
        ngo_name: "The Children's Inn at NIH",
        ngo_id: "0",
      },
      {
        name: "Hamid",
        age: "12 ans",
        country: "Afghanistan",
        short_desc: "Hamid, 12 ans, de l'Afghanistan",
        desc: [
          "Hamid est un artiste très talentueux. Il aime dessiner et peindre. Il aime beaucoup les animaux et la nature. C'est une personne très gentille et attentionnée et il aime aider les autres. Il est très heureux de faire partie de cette initiative et espère aider d'autres enfants comme lui.",
        ],
        img: "/assets/images/kids/hamid.jpg",
        id: "2",
        ngo_name: "Children First Canada",
        ngo_id: "2",
      },
      {
        name: "Aarav",
        age: "10 ans",
        country: "Iran",
        short_desc: "Aarav, 10 ans, de l'Iran",
        desc: [
          "Aarav vient de la partie défavorisée du nord de l'Iran. C'est un élève très brillant et il s'intéresse beaucoup à la science dont la capacité à poursuivre ses rêves est limitée par la situation financière de sa famille.",
        ],
        img: "/assets/images/kids/aarav.jpg",
        id: "3",
        ngo_name: "Smile Foundation",
        ngo_id: "1",
      },
      {
        name: "Sara",
        age: "8 ans",
        country: "Syria",
        short_desc: "Sara, 8 ans, de l'Syria",
        desc: [
          "Sara vient de la partie défavorisée du nord de l'Iran. C'est une élève très brillante et elle s'intéresse beaucoup à la science dont la capacité à poursuivre ses rêves est limitée par la situation financière de sa famille.",
        ],
        img: "/assets/images/kids/sara.jpg",
        id: "4",
        ngo_name: "The Children's Inn at NIH",
        ngo_id: "0",
      },
    ],
  },
};

export default kids_data;
